<template>
  <router-link
    :to="{name: 'player_chat_unblock', params: {playerId: playerId, chatUnblockId: chatUnblockId}}"
  >
    {{lable}} {{chatUnblockId}}
  </router-link>
</template>

<script>
export default {
  name: 'PlayerChatUnblockLink',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    chatUnblockId: {
      type: Number,
      required: true,
    },

    lable: {
      type: String,
      default: 'Chat unblock'
    }
  },
};
</script>
